import { ApiUrl } from '@common/enums';
import { EdgeModel } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const edgesService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchEdges: builder.query<EdgeModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.EDGES,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchEdgesQuery, useLazyFetchEdgesQuery } = edgesService;
